/*
 * @Author: liuxw@codoon.com
 * @Date: 2021-07-08 16:08:40
 * @Last Modified by:   liuxw@codoon.com
 * @Last Modified time: 2021-07-08 16:08:40
 */

import { SystemFun } from "codoon-fun";

export const isIosBangsDevice = SystemFun.checkIsIosBangsDevice();

export const system = SystemFun.checkSystemByUserAgent();
